<div class="modal fade modal-full-width modal-full-height" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" *ngIf="modal.isOpen">
            <div class="modal-header">
                <ng-template [ngIf]="modal.data.isPerspectivaRAP">
                    <h4 class="modal-title">
                        Análise de Mercado RAP - Receita Anual Pretendida
                    </h4>
                </ng-template>

                <ng-template [ngIf]="modal.data.isPerspectivaClassificacao">
                    <h4 class="modal-title">
                        Análise de Mercado de Segmentos
                    </h4>
                </ng-template>
                
                <ng-template [ngIf]="modal.data.isPerspectivaProjetada">
                    <h4 class="modal-title">
                        Análise de Mercado Projetada
                    </h4>              
                </ng-template>                
            </div>
            <div class="modal-body">
                <sgt-cliente-analise-mercado-form
                    #form>
                </sgt-cliente-analise-mercado-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Fechar
                </button>               
            </div>
        </div>
    </div>
</div>
